import s from "./Reinvented.module.scss";
import { useTranslation } from "react-i18next";
import ParagraphReveal from "../ParagraphReveal/ParagraphReveal";
import { useEffect, useRef } from "react";
import { useStore } from "../../store/store";
import { gsap } from "gsap";
import { titleInEase } from "../../utils/Eases";

const Reinvented = () => {
  const { t } = useTranslation();
  const titleRef = useRef();
  const loadingScreen = useStore((state) => state.loadingScreen);
  const spansToTranslate = useRef();
  const spansToRotate = useRef();
  const subtitleRef = useRef();
  const introRef = useRef();

  useEffect(() => {
    // const spans = t("reinvented.dior", { returnObjects: true });
    // console.log(spans);

    // spans.forEach((span) => {});
    spansToTranslate.current = [
      document.querySelectorAll("[data-wrapper-1] span:not([data-rotation])"),
      document.querySelectorAll("[data-wrapper-2] span:not([data-rotation])"),
      document.querySelectorAll("[data-wrapper-3] span:not([data-rotation])"),
      document.querySelectorAll("[data-wrapper-4] span:not([data-rotation])"),
    ];
    spansToRotate.current = document.querySelectorAll(
      "#reinvented span[data-rotation]"
    );
    gsap.set(spansToTranslate.current, {
      y: "150%",
      opacity: 0,
    });
    gsap.set(spansToRotate.current, {
      transformOrigin: "center center",
      rotateX: -270,
      opacity: 0,
      y: "15%",
    });

    gsap.set([subtitleRef.current, introRef.current], {
      y: "150%",
      opacity: 0,
    });
  }, []);

  useEffect(() => {
    if (process.env.NODE_ENV === "development" || loadingScreen === false) {
      gsap.fromTo(
        spansToTranslate.current,
        {
          y: "150%",
          opacity: 0,
        },
        {
          ease: titleInEase,
          opacity: 1,
          y: "15%",
          stagger: 0.05,
          duration: 1.2,
        }
      );

      gsap.fromTo(
        [subtitleRef.current, introRef.current],
        {
          y: "150%",
          opacity: 0,
        },
        {
          ease: titleInEase,
          opacity: 1,
          delay: 1.2,
          y: "15%",
          stagger: 0.2,
          duration: 1.2,
        }
      );

      // spansToTranslate.current.forEach((span) => {
      //   gsap.fromTo(
      //     span,
      //     {
      //       y: "150%",
      //       opacity: 0,
      //     },
      //     {
      //       ease: titleInEase,
      //       opacity: 1,
      //       y: "15%",
      //       stagger: 0.05,
      //       duration: 1.2,
      //     }
      //   );
      // });

      gsap.fromTo(
        spansToRotate.current,
        {
          transformOrigin: "center center",
          rotateX: -270,
          opacity: 0,
          y: "15%",
        },
        {
          ease: titleInEase,
          opacity: 1,
          duration: 1.2,
          stagger: 0.5,
          rotateX: 0,
        }
      );
    }
  }, [loadingScreen]);

  return (
    <div className={s.wrapper}>
      <h1 id="reinvented" ref={titleRef}>
        <div data-wrapper-1 className={s.dior}>
          <span>D</span>
          <span>I</span>
          <span data-rotation className={`salmon`}>
            O
          </span>
          <span>R</span>

          {/* attempt 3 */}
          {/* {t("reinvented.dior", { returnObjects: true }).map((fn) => {
            return fn();
          })} */}
        </div>
        <div data-wrapper-2 className={s.reinvented}>
          <div>
            {t("reinvented.reinvented", { returnObjects: true }).map(
              (item, index) => {
                return (
                  <span
                    key={item.letter + index}
                    className={item.className}
                    {...item.attributes}
                  >
                    {item.letter}
                  </span>
                );
              }
            )}
          </div>
          <div className={s.by}>
            {t("reinvented.by", { returnObjects: true }).map((item, index) => {
              return (
                <span
                  key={item.letter + index}
                  className={item.className}
                  {...item.attributes}
                >
                  {item.letter}
                </span>
              );
            })}
          </div>
        </div>
        <div data-wrapper-3 className={s.philippe}>
          <span>P</span>
          <span>H</span>
          <span>I</span>
          <span>L</span>
          <span>I</span>
          <span>P</span>
          <span>P</span>
          <span>E</span>
        </div>
        <div data-wrapper-4 className={s.starck}>
          <span>S</span>
          <span data-rotation className={`red`}>
            T
          </span>
          <span>A</span>
          <span>R</span>
          <span>C</span>
          <span>K</span>
        </div>
      </h1>

      <div className={s.description}>
        <p ref={subtitleRef} className={s.subtitle}>
          Monsieur Dior, <br />
          {t("reinvented.subtitle")}
        </p>
        <p ref={introRef} className={s.intro}>
          {t("reinvented.intro")}
        </p>
        {t("reinvented.description", { returnObjects: true }).map((item) => {
          return (
            <ParagraphReveal
              key={item}
              className={s.paragraph}
              triggerWhenScroll={false}
              trigger={
                process.env.NODE_ENV === "development" ? true : !loadingScreen
              }
              delay={1.5}
            >
              {item}
            </ParagraphReveal>
          );
        })}
      </div>
    </div>
  );
};

export default Reinvented;
